import { Button } from 'antd';
import cls from 'clsx';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { images } from '@/shared/assets/images/images';
import { useIsMobile } from '@/shared/lib/useIsMobile';
import { AuthFrame } from '@/widgets/auth-frame';

import s from '@/shared/ui/AuthForm.module.css';

export function CheckoutSuccessPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  useEffect(() => {
    document.title = 'Success - In_Home';
  }, []);

  function handleNavigate() {
    navigate('/dashboard', { replace: true });
  }

  return (
    <AuthFrame header={false}>
      <div className={cls(s.content, s.success, s.checkout)}>
        <div className={s.pageContent}>
          <div className={s.title}>
            <h2>{t('Welcome to In_Home')}</h2>
            <div>{t('You now have access to In_Home')}</div>
          </div>

          <img
            src={
              isMobile ? images.checkoutSuccessMobile : images.checkoutSuccess
            }
            alt=""
          />

          <Button
            type="primary"
            className={s.pageButton}
            onClick={handleNavigate}
          >
            {t('Go To Dashboard')}
          </Button>
        </div>
      </div>
    </AuthFrame>
  );
}
